<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
      @toggle-favorite="forwardToggleFavorite"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    'vertical-nav-menu-header': VerticalNavMenuHeader,
    'vertical-nav-menu-link': VerticalNavMenuLink,
    'vertical-nav-menu-group': VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    provide('openGroups', ref([]))

    const forwardToggleFavorite = (item, isFavorite) => {
      emit('toggle-favorite', item, isFavorite)
    }

    return {
      resolveNavItemComponent,
      forwardToggleFavorite,
    }
  },
}
</script>
